import { ITechnicianAdapter, TechnicianJobFilter } from './ITechnicianAdapter';
import { ApiResponse } from '../../types/api';
import {
  TechnicianJob,
  AcceptJobDto,
  StartJobDto,
  AddPhotoDto,
  AddMaterialDto,
  AddProgressDto,
  CompleteJobDto,
} from '../../types/technicianJob';
import { ApiClient as apiClient } from '../apiClient';

export class LaravelTechnicianAdapter implements ITechnicianAdapter {
  private readonly BASE = '/api/technician/jobs';

  async getJobs(technicianId: string, filter?: TechnicianJobFilter): Promise<ApiResponse<TechnicianJob[]>> {
    const params = new URLSearchParams();
    params.set('technician_id', technicianId);
    if (filter?.status) params.set('status', filter.status);
    if (filter?.search) params.set('search', filter.search);
    return apiClient.get<TechnicianJob[]>(`${this.BASE}?${params.toString()}`);
  }

  async getJobById(jobId: string): Promise<ApiResponse<TechnicianJob>> {
    return apiClient.get<TechnicianJob>(`${this.BASE}/${jobId}`);
  }

  async acceptJob(dto: AcceptJobDto): Promise<ApiResponse<TechnicianJob>> {
    return apiClient.post<TechnicianJob>(`${this.BASE}/${dto.job_id}/accept`, dto);
  }

  async startJob(dto: StartJobDto): Promise<ApiResponse<TechnicianJob>> {
    return apiClient.post<TechnicianJob>(`${this.BASE}/${dto.job_id}/start`, dto);
  }

  async addPhoto(dto: AddPhotoDto): Promise<ApiResponse<TechnicianJob>> {
    return apiClient.post<TechnicianJob>(`${this.BASE}/${dto.job_id}/photos`, dto);
  }

  async addMaterial(dto: AddMaterialDto): Promise<ApiResponse<TechnicianJob>> {
    return apiClient.post<TechnicianJob>(`${this.BASE}/${dto.job_id}/materials`, dto);
  }

  async addProgress(dto: AddProgressDto): Promise<ApiResponse<TechnicianJob>> {
    return apiClient.post<TechnicianJob>(`${this.BASE}/${dto.job_id}/progress`, dto);
  }

  async completeJob(dto: CompleteJobDto): Promise<ApiResponse<TechnicianJob>> {
    return apiClient.post<TechnicianJob>(`${this.BASE}/${dto.job_id}/complete`, dto);
  }
}
